import Swiper from '../../common/custom-swiper/custom-swiper';
import LazyLoad from '../../../js/lazy-load';

export default new class TwoLevelSlider {
  constructor() {
    this.sliderAjaxWrapper = 'catalog-home-slider__slider';
    this.sliderContainerSelector = 'catalog-home-slider__container';
    this.wrapperSelector = 'catalog-home-slider__wrapper';
    this.wrapperFlexSelector = 'catalog-home-slider__wrapper_flex';
    this.preLoaderSelector = 'catalog-home-slider__preloader';
    this.TwoLevelSlider = null;

    this.init();
  }

  init() {
    const breakpoint = window.matchMedia('(min-width: 768px)');

    const breakpointChecker = (event) => {
      if (event.matches) {
        if (this.TwoLevelSlider !== null) {
          this.TwoLevelSlider.destroy(true, true);
          this.TwoLevelSlider = null;
        }
      } else {
        if (this.TwoLevelSlider === null) {
          this.TwoLevelSlider = new Swiper(`.${this.sliderContainerSelector}`, {
            slidesPerView: 'auto',
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            spaceBetween: 12,
            breakpointsInverse: true,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            observer: true,
            loop: false,
            slidesOffsetBefore: 15,
            breakpoints: {
              769: {
                spaceBetween: 0,
                slidesOffsetBefore: 0,
              },
            },
            on: {
              init: () => {
                const slider = document.querySelector(`.${this.sliderContainerSelector}`);
                const wrapper = slider.querySelector(`.${this.wrapperSelector}`);
                wrapper.classList.add(this.wrapperFlexSelector);
              },
            },
          });
        }
      }
    };

    breakpoint.addEventListener('change', breakpointChecker);
    breakpointChecker(breakpoint);
  }
}();
